import axios from 'axios';
import { API_BASE_URL } from '@/constants';

export const fetchComments = async (petId: number): Promise<Comment[]> => {
  const response = await axios.get(`${API_BASE_URL}/comments/?pet=${petId}`);
  return response.data;
};

export const createComment = async (
  content: string,
  petId: number,
  token: string,
  parentId?: number,
): Promise<Comment> => {
  const response = await axios.post(
    `${API_BASE_URL}/comments/`,
    { content, pet: petId, parent: parentId ?? null },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return response.data;
};

export const updateComment = async (
  id: number,
  content: string,
  token: string,
): Promise<Comment> => {
  const response = await axios.patch(
    `${API_BASE_URL}/comments/${id}/`,
    { content },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return response.data;
};

export const deleteComment = async (id: number, token: string): Promise<void> => {
  await axios.delete(`${API_BASE_URL}/comments/${id}/`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const reactToComment = async (
  commentId: number,
  reaction: 'like' | 'dislike',
  token: string,
): Promise<{ status: string }> => {
  const response = await axios.post(
    `${API_BASE_URL}/comments/${commentId}/react/`,
    { reaction },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return response.data;
};
